import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class TransferCouponCodeService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    private transferCouponCodeUrl = 'api/couponCodeClient';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    searchClientsForTransfer(search_data: string): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('search_data', search_data);

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.transferCouponCodeUrl}/searchClientsForTransfer`;
        return this.http.get(url, options)
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    getClientCouponCodes(client_id: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('client_id', client_id);

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.transferCouponCodeUrl}/getClientCouponCodes`;
        return this.http.get(url, options)
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    transferCouponCode(data: any): Promise<any> {
        const url = `${this.transferCouponCodeUrl}/transferCouponCode`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    getTransferCouponCodeList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.transferCouponCodeUrl}/getTransferCouponCodeList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/transferCouponCode.service.ts